define('views/modules/setting/business/blocks/payment/payment-list',[
    // Libs
    'underscore', 'backbone',
    // views
    'views/parts/list/list',
    'views/modules/setting/business/blocks/payment/payment-list-item',
], function(
    // Libs
    _, Backbone,
    // views
    VList,
    VPaymentListItem
) {

    var VPaymentList = VList.extend({
        item: VPaymentListItem,

        getItemOptions: function(options) {
            return _.extend(options, _.pick(this.options, ['membershipPlans']));
        },

    });

    return VPaymentList;
});

